import { BlankString } from "../Constants";
import { HTTPStatusCodes } from "../Constants";
import { ErrorMessages } from "../Constants";
import { HttpRequestMethods } from "../Constants";
import { API_URL } from "../Constants";

interface IFetch {
  error: boolean;
  statusCode: number,
  errorMessage: string;
  data: any
};

interface IRequestParams {
  method: string,
  credentials: RequestCredentials,
  headers: {},
  body? : string
}

export async function GetData(requestOptions: any, httpMethod: string, methodString: string | undefined, token: string): Promise<IFetch> {
  const requestParams: IRequestParams = {
    method: httpMethod,
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
    body: JSON.stringify(requestOptions)
  };

  if(httpMethod === HttpRequestMethods.GET){
    delete requestParams['body'];
  }

  const response = await fetch(`${API_URL}${methodString}`, requestParams).then((response: any) => response).catch((error) => {
    return { 
      error: true, 
      statusCode: HTTPStatusCodes.InternalServerError, 
      errorMessage: ErrorMessages.NetworkError, 
      data: BlankString 
    };
  });

  if (response.status === HTTPStatusCodes.OK || response.status === HTTPStatusCodes.Created) {
    const data = await response.json();
    return { 
      error: false, 
      statusCode: HTTPStatusCodes.OK, 
      errorMessage: BlankString, 
      data: data 
    };
  };

  if (response.status === HTTPStatusCodes.InternalServerError || response.status === HTTPStatusCodes.BadRequest) {
    const data = await response.json();
    if(data) {
      return { 
        error: true, 
        statusCode: response.status, 
        errorMessage: data.errorMessage, 
        data: data
      };
    }
  };

  return { 
    error: true, 
    statusCode: response.status, 
    errorMessage: response.status === HTTPStatusCodes.UnAuthorized ? ErrorMessages.ExpiredToken : (response.status === HTTPStatusCodes.Forbidden ? ErrorMessages.Forbidden : (response.status === HTTPStatusCodes.InternalServerError ? ErrorMessages.InernalServerError : response.errorMessage)), 
    data: BlankString 
  };
};

export async function PostData(requestOptions: any, methodString: string | undefined, token: string = BlankString): Promise<IFetch> {
  return GetData(requestOptions, HttpRequestMethods.POST, methodString, token);
};

export async function PutData(requestOptions: any, methodString: string | undefined, token: string = BlankString): Promise<IFetch> {
  return GetData(requestOptions, HttpRequestMethods.PUT, methodString, token);
};

export async function PatchData(requestOptions: any, methodString: string | undefined, token: string = BlankString): Promise<IFetch> {
  return GetData(requestOptions, HttpRequestMethods.PATCH, methodString, token);
};